import * as Yup from "yup";
import { getInitialValues } from "layouts/views/common/common"



const formField = {
    shippingZone: {
        name: "shippingZone",
        label: "Shipping Zone",
        type: "text",
        errorMsg: "Shipping Zone is required.",
        required: true,
        editable: false
    },
    postcodeFrom: {
        name: "postcodeFrom",
        label: "Postcode From",
        type: "text",
        errorMsg: "Postcode From is required.",
        required: true
    },
    postcodeTo: {
        name: "postcodeTo",
        label: "Postcode To",
        type: "text",
        errorMsg: "Postcode To is required.",
        required: true
    },
    descriptions1: {
        name: "descriptions1",
        label: "Descriptions 1",
        type: "text",
    },
    descriptions2: {
        name: "descriptions2",
        label: "Descriptions 2",
        type: "text",
    },
    shipZoneGroup1: {
        name: "shipZoneGroup1",
        label: "Ship Zone Group 1",
        type: "select",
        size: 6,
    },
    shipZoneGroup2: {
        name: "shipZoneGroup2",
        label: "Ship Zone Group 2",
        type: "text",
        size: 6,
    },
    shipZoneGroup3: {
        name: "shipZoneGroup3",
        label: "Ship Zone Group 3",
        type: "text",
        size: 6,
    },
    countryCode: {
        name: "countryCode",
        label: "Country Code",
        type: "select",
        errorMsg: "Country Code is required.",
        required: true,
    },
    remark: {
        name: "remark",
        label: "Remark",
        type: "text",
    },
}

const {
    shippingZone, postcodeFrom, postcodeTo, descriptions1, descriptions2, shipZoneGroup1, shipZoneGroup2, shipZoneGroup3, countryCode, remark
} = formField;

export const form = {
    formId: "shipping-zone-form",
    formField,
    formRender: [
        [shippingZone],
        [postcodeFrom, postcodeTo],
        [descriptions1, descriptions2],
        [shipZoneGroup1],
        [shipZoneGroup2],
        [shipZoneGroup3],
        [countryCode, remark],
    ],
};

export const formRender= [
    [shippingZone],
    [postcodeFrom, postcodeTo],
    [descriptions1, descriptions2],
    [shipZoneGroup1],
    [shipZoneGroup2],
    [shipZoneGroup3],
    [countryCode, remark],
]

export const initialValues = getInitialValues(formField);

export const shippingZoneValidation = Yup.object().shape({
    [shippingZone.name]: Yup.string().nullable().max(20).required(shippingZone.errorMsg),
    [postcodeFrom.name]: Yup.string().nullable().max(10).required(postcodeFrom.errorMsg),
    [postcodeTo.name]: Yup.string().nullable().max(10).required(postcodeTo.errorMsg),
    [descriptions1.name]: Yup.string().nullable().max(100),
    [descriptions2.name]: Yup.string().nullable().max(100),
    [shipZoneGroup2.name]: Yup.string().nullable().max(20),
    [shipZoneGroup3.name]: Yup.string().nullable().max(20),
    [countryCode.name]: Yup.string().nullable().max(10).required(countryCode.errorMsg),
    [remark.name]: Yup.string().nullable().max(250),
})